import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import BookConsultation from './pages/BookConsultation';
import Footer from './components/Footer';

// Component to scroll to top and update title on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Update page title based on route
    const titles = {
      '/': 'Canadian Umbrella Immigration - Lisa Halliwell, RCIC | Charlottetown, PE',
      '/about': 'About Lisa Halliwell, RCIC | Canadian Umbrella Immigration Services',
      '/services': 'Immigration Services | Canadian Umbrella Immigration',
      '/book-consultation': 'Book Consultation with Lisa Halliwell, RCIC | Canadian Umbrella'
    };
    
    document.title = titles[pathname] || titles['/'];
    
    // Update canonical URL for SEO
    const baseUrl = 'https://canadianumbrellaimmigration.ca';
    const canonicalUrl = baseUrl + (pathname === '/' ? '' : pathname);
    
    // Remove existing canonical link if any
    let existingCanonical = document.querySelector('link[rel="canonical"]');
    if (existingCanonical) {
      existingCanonical.remove();
    }
    
    // Add new canonical link
    const link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', canonicalUrl);
    document.head.appendChild(link);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/book-consultation" element={<BookConsultation />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
